import { Fragment } from 'react'
import { formatPaise, type Paise } from '@/lib/money'

/** `**bold**` inside a message. */
export function Rich({ text }: { text: string }) {
  return (
    <>
      {text
        .split('**')
        .map((part, i) => (i % 2 ? <b key={i}>{part}</b> : <Fragment key={i}>{part}</Fragment>))}
    </>
  )
}

/** "₹36,673" + small ".50", as on the slip and the lot cards. */
export function Money({ paise, small = 0.6 }: { paise: Paise; small?: number }) {
  const s = formatPaise(paise)
  const dot = s.lastIndexOf('.')
  return (
    <>
      {s.slice(0, dot)}
      <span style={{ fontSize: `${small}em` }}>{s.slice(dot)}</span>
    </>
  )
}
